<template>
  <div>
    <v-container class="content-wrapper" fluid id="news-events-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            News & Events
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <TableNewsAndEvents
              :url-api="'/api/v1/news-and-events'"
              :search="search"
              :search-attributes="['title']"
            ></TableNewsAndEvents>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TableNewsAndEvents from './TableNewsAndEvents.vue';

export default {
  name: 'NewsAndEvents',
  components: { TableNewsAndEvents },
  data: () => ({
    search: {},
  }),
};
</script>
